import { property, state } from "lit/decorators.js";
import { QuoteController } from "./quote-controller.js";
import { SelectedState } from "./selected-state.js";
import "../common/payment-element.js";
import offerBoxStyles from "./offer-box-styles.js";
import { BaseElement } from "./base-element.js";
import { OfferPaymentMixin } from "./mixin/offer-payment-mixin.js";
import { standardDisplayTemplate } from "./utils.js";
var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const _QuoteElement = class _QuoteElement extends OfferPaymentMixin(BaseElement) {
  constructor(product) {
    super();
    this.customerCountry = "US";
    this.landingPageAction = false;
    this.shouldOverrideQuote = false;
    this.quoteContext = this.quote;
    this.product = product;
    if (!this.shouldOverrideQuote) {
      this.quoteController = new QuoteController(this, () => {
        this.quoteContext = this.quote;
        this.triggerOfferStateChangeEvent();
      });
    }
  }
  get quote() {
    var _a;
    return this.quoteOverride ?? ((_a = this.quoteController) == null ? void 0 : _a.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updated(_changedProperties) {
    if (_changedProperties.has("quoteOverride")) {
      this.quoteContext = this.quoteOverride;
    }
  }
  connectedCallback() {
    super.connectedCallback();
    if (!document.getElementById("payment-component-style-overrides")) {
      const componentStyles = document.createElement("style");
      componentStyles.setAttribute("id", "vi-component-style-overrides");
      if (componentStyles) {
        componentStyles.innerHTML = `
          :root {
            --vi-font-fallback: ui-sans-serif, system-ui, sans-serif;
            --default-vi-font-family: var(--vi-font-family, var(--vi-font-fallback));
            --default-vi-multi-offer-header-font-size: var(--vi-multi-offer-header-font-size,  0.95rem);

            --default-vi-primary-color: var(--vi-primary-color, #FF6B00);
            --default-vi-primary-contrast-color: var(--vi-primary-contrast-color, #FFF1E3);
            --default-vi-neutral-color: var(--vi-neutral-color, #F4F6F6);
            --default-vi-neutral-contrast-color: var(--vi-neutral-contrast-color, #000000);
            --default-vi-font-xs: var(--vi-font-xs, 0.75rem);
            --default-vi-font-sm: var(--vi-font-sm, 0.8rem);
            --default-vi-font-md: var(--vi-font-md, 0.9rem);
            --default-vi-font-lg: var(--vi-font-lg, 1.05rem);
            --default-vi-font-xl: var(--vi-font-xl, 1.25rem);
            --default-vi-secondary-color: var(--vi-secondary-color, #FF6B00);
            --default-vi-secondary-contrast-color: var(--vi-secondary-contrast-color, #FFF1E3);
            --default-vi-bg-color: var(--vi-bg-color, #ffffff);
            --default-vi-success-color: var(--vi-success-color, #FF6B00);
            --default-vi-success-bg-color: var(--vi-success-bg-color, #EFEFEE);
            --default-vi-success-border-color: var(--vi-success-border-color, #918F8F);
            --default-vi-danger-color: var(--vi-danger-color, #C71414);
            --default-vi-danger-bg-color: var(--vi-danger-bg-color, #FDEDED);
            --default-vi-danger-border-color: var(--vi-danger-border-color, #C71414);
            --default-vi-warning-color: var(--vi-warning-color, #fbbf24);
            --default-vi-warning-bg-color: var(--vi-warning-bg-color, #fffbeb);
            --default-vi-warning-border-color: var(--vi-warning-border-color, #fbbf24);
            --default-vi-tag-color: var(--vi-tag-color, #FF6B00);
            --default-vi-tag-contrast-color: var(--vi-tag-contrast-color, #ffffff);
            --default-vi-tag-display: var(--vi-tag-display, block);
            --default-vi-link-color: var(--vi-link-color, #000000);
            --default-vi-checkmark-scale: var(--vi-checkmark-scale, 1);
            --default-vi-border-color: var(--vi-border-color, #949293);
            --default-vi-border-radius: var(--vi-border-radius, 10px);
            
            --default-vi-radio-default-color: var(--vi-radio-default-color, #000000);
            --default-vi-radio-default-border: var(--vi-radio-default-border, 1px solid #000000);

            --default-vi-promotional-header-font-family: var(--vi-promotional-header-font-family, var(--default-vi-font-family));
            --default-vi-promotional-header-font-weight: var(--vi-promotional-header-font-weight, 700);
            --default-vi-promotional-header-font-size: var(--vi-promotional-header-font-size, var(--default-vi-font-xl));
            --default-vi-promotional-header-color: var(--vi-promotional-header-color, #000000);

            --default-vi-promotional-description-color: var(--vi-promotional-description-color, #000000);
            --default-vi-promotional-description-font-family: var(--vi-promotional-description-font-family, var(--default-vi-font-family));
            --default-vi-promotional-description-font-weight: var(--vi-promotional-description-font-weight, 400);
            --default-vi-promotional-description-font-size: var(--vi-promotional-description-font-size, var(--default-vi-font-md));

            --default-vi-container-padding: var(--vi-container-padding, 16px 16px 16px 16px);
            
            --default-vi-action-border-radius: var(--vi-action-border-radius, 4px);
            --default-vi-action-spacing: var(--vi-action-spacing, 8px);
            --default-vi-action-accept-text-color: var(--vi-action-accept-text-color, #FF6B00);
            --default-vi-action-accept-radio-color: var(--vi-action-accept-radio-color, #FF6B00);
            --default-vi-action-accept-bg-color: var(--vi-action-accept-bg-color, #EFEFEE);
            --default-vi-action-accept-border-color: var(--vi-action-accept-border-color, #918F8F);
            --default-vi-action-accept-font-weight: var(--vi-action-accept-font-weight, 700);
            --default-vi-action-decline-text-color: var(--vi-action-decline-text-color, #000000);
            --default-vi-action-decline-radio-color: var(--vi-action-decline-radio-color, #000000);
            --default-vi-action-decline-bg-color: var(--vi-action-decline-bg-color, #EFEFEE);
            --default-vi-action-decline-border-color: var(--vi-action-decline-border-color, #918F8F);
            --default-vi-action-decline-font-weight: var(--vi-action-decline-font-weight, 400);
            --default-vi-action-radio-scale: var(--vi-action-radio-scale, 1); 
            --default-vi-action-checkbox-scale: var(--vi-action-checkbox-scale, 1); 
            --default-vi-action-padding: var(--vi-action-padding, 12px 18px);
            --default-vi-action-required-label-font-weight: var(--vi-action-required-label-font-weight, 700);
            --default-vi-action-checklist-item-padding: var(--vi-action-checklist-item-padding, 10px 12px);
            --default-vi-action-header-font-family: var(--vi-action-header-font-family, inherit);
            --default-vi-action-header-font-weight: var(--vi-action-header-font-weight, 600);
            --default-vi-action-header-font-size: var(--vi-action-header-font-size, var(--default-vi-font-md));
            --default-vi-descriptors-checkmark-accept-color: var(--vi-descriptors-checkmark-accept-color, #FF6B00);
            --default-vi-descriptors-checkmark-decline-color: var(--vi-descriptors-checkmark-decline-color, #000000);
            --default-vi-descriptors-spacing-x: var(--vi-descriptors-spacing-x, 15px);
            --default-vi-descriptors-spacing-y: var(--vi-descriptors-spacing-y, 10px);

            --default-vi-offer-display-spacing: var(--vi-offer-display-spacing, 10px);
            --default-vi-offer-content-spacing: var(--vi-offer-content-spacing, 30px);
            --default-vi-offer-header-spacing: var(--vi-offer-header-spacing, 10px);
            --default-vi-package-display-spacing: var(--vi-package-display-spacing, 10px);
            
            --default-vi-error-font-family: var(--vi-error-font-family, inherit);
            --default-vi-error-font-weight: var(--vi-error-font-weight, 400);
            --default-vi-error-font-size: var(--vi-error-font-size, var(--default-vi-font-md));

            --default-vi-tab-navigation-button-border: var(--vi-tab-navigation-button-border, 2px solid var(--vi-primary-color, #FF6B00));
            --default-vi-tab-navigation-button-background: var(--vi-tab-navigation-button-background, var(--vi-primary-color, #FF6B00));
            --default-vi-tab-navigation-button-color: var(--vi-tab-navigation-button-color, var(--vi-primary-contrast-color, #FFF1E3));

            --jfi-layout-padding: 0 0 4px 0;
            --jfi-layout-form-control-spacing-x: .5rem;
            --jfi-layout-form-control-spacing-y: 1rem;
            --jfi-layout-font-family: var(--default-vi-font-family);
            --jfi-form-label-font-family: var(--default-vi-font-family);
            --jfi-primary-color: var(--default-vi-primary-color);
            --jfi-form-control-background-color: #ffffff;
            --jfi-form-control-border-color: rgb(226, 232, 240);
            --jfi-form-control-border-color-focus: rgba(0, 0, 0, 0.62);
            --jfi-form-control-border-color-error: var(--default-vi-danger-color);
            --jfi-form-control-border-width: 1px;
            --jfi-form-control-border-radius: 4px;
            --jfi-form-control-border-style: solid;
            --jfi-form-control-box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
            --jfi-form-control-box-shadow-error: rgba(199, 20, 20, 0.15) 0px 0px 0px 0px, rgba(199, 20, 20, 0.15) 0px 0px 0px 0px, rgba(199, 20, 20, 0.15) 0px 1px 2px 0px;
            --jfi-form-control-box-shadow-error-focus: none;
            --jfi-form-control-box-shadow-focus: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
            --jfi-form-control-color: #000000;
            --jfi-form-control-color-focus: var(--default-vi-primary-color);
            --jfi-form-control-font-size: 0.85rem;
            --jfi-form-control-font-weight: 400;
            --jfi-form-control-line-height: 2;
            --jfi-form-control-margin: 0;
            --jfi-form-control-padding: .25rem .75rem;
            --jfi-form-label-font-size: 0.95rem;
            --jfi-form-label-margin: 0 0 4px 2px;
            --jfi-error-message-color: var(--default-vi-danger-color);
            --jfi-error-message-margin: 4px 0 0 2px;
            --jfi-error-message-font-size: var(--default-vi-font-sm);
          }
        `;
        document.body.append(componentStyles);
      }
    }
  }
  /**
   * @ignore
   */
  get customer() {
    return {
      first_name: this.customerFirstName,
      last_name: this.customerLastName,
      email_address: this.customerEmailAddress,
      street: this.customerStreetAddress,
      city: this.customerCity,
      state: this.customerState,
      postal_code: this.customerPostalCode,
      country: this.customerCountry
    };
  }
  /**
   * @ignore
   */
  get productTemplate() {
    var _a, _b, _c, _d, _e;
    return {
      promotional_header: ((_a = this.quote) == null ? void 0 : _a.product.promotional_header) || ((_b = this.quote) == null ? void 0 : _b.product.friendly_name),
      promotional_description: ((_c = this.quote) == null ? void 0 : _c.product.promotional_description) || void 0,
      accept_action_text: ((_d = this.quote) == null ? void 0 : _d.product.accept_action_text) || void 0,
      decline_action_text: ((_e = this.quote) == null ? void 0 : _e.product.decline_action_text) || "Decline coverage"
    };
  }
  accept() {
    this.errors = [];
    this.selectedState = SelectedState.ACCEPTED;
    this.triggerOfferStateChangeEvent();
  }
  decline() {
    this.errors = [];
    this.selectedState = SelectedState.DECLINED;
    this.triggerOfferStateChangeEvent();
  }
  reset() {
    this.errors = [];
    this.selectedState = SelectedState.UNKNOWN;
    this.triggerOfferStateChangeEvent();
  }
  get total() {
    var _a, _b;
    return ((_a = this.quote) == null ? void 0 : _a.total) || ((_b = this.quote) == null ? void 0 : _b.premium_amount);
  }
  /**
   * @ignore
   */
  get quoteId() {
    return localStorage.getItem(this.storageKey);
  }
  /**
   * @ignore
   */
  set quoteId(quoteId) {
    localStorage.setItem(this.storageKey, quoteId);
  }
  /**
   * @ignore
   */
  unsetQuoteId() {
    localStorage.removeItem(this.storageKey);
  }
  get storageKey() {
    var _a, _b;
    return ((_a = this.dataset) == null ? void 0 : _a.uniqueId) ? `_vi_quote_id:${this.product}:${(_b = this.dataset) == null ? void 0 : _b.uniqueId}` : `_vi_quote_id:${this.product}`;
  }
  /**
   * @ignore
   */
  get offerId() {
    return localStorage.getItem(this.offerIdStorageKey);
  }
  /**
   * @ignore
   */
  set offerId(offerId) {
    if (offerId) localStorage.setItem(this.offerIdStorageKey, offerId);
  }
  /**
   * @ignore
   */
  unsetOfferId() {
    localStorage.removeItem(this.offerIdStorageKey);
  }
  /**
   * @ignore
   */
  get offerIdStorageKey() {
    return "_vi_offer_id:" + this.product;
  }
  get displayPaymentElement() {
    return this.selectedState === SelectedState.ACCEPTED && this.includePaymentElement;
  }
  triggerOfferStateChangeEvent() {
    const options = {
      detail: {
        quote: this.quote,
        selectedState: SelectedState[this.selectedState]
      },
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent("offer-state-change", options));
    if (this.debug) {
      console.debug("Fired offer-state-change event", options.detail);
    }
  }
  toggleOfferSelection() {
    if (this.selectedState === SelectedState.ACCEPTED) {
      this.decline();
    } else {
      this.accept();
    }
  }
  render() {
    return this.shouldOverrideQuote && this.quoteOverride ? this._renderStandardDisplay() : this.quoteController.render({ complete: () => this._renderStandardDisplay() });
  }
  _renderStandardDisplay() {
    return standardDisplayTemplate(this.selectedState, this.accept, this.decline, () => this.renderPaymentElement(), this.landingPageAction, this.quote, this.productTemplate, this.errors);
  }
};
_QuoteElement.styles = offerBoxStyles;
let QuoteElement = _QuoteElement;
__decorateClass([
  property({ attribute: "customer-first-name" })
], QuoteElement.prototype, "customerFirstName");
__decorateClass([
  property({ attribute: "customer-last-name" })
], QuoteElement.prototype, "customerLastName");
__decorateClass([
  property({ attribute: "customer-email-address" })
], QuoteElement.prototype, "customerEmailAddress");
__decorateClass([
  property({ attribute: "customer-street-address" })
], QuoteElement.prototype, "customerStreetAddress");
__decorateClass([
  property({ attribute: "customer-state" })
], QuoteElement.prototype, "customerState");
__decorateClass([
  property({ attribute: "customer-city" })
], QuoteElement.prototype, "customerCity");
__decorateClass([
  property({ attribute: "customer-postal-code" })
], QuoteElement.prototype, "customerPostalCode");
__decorateClass([
  property({ attribute: "customer-country" })
], QuoteElement.prototype, "customerCountry");
__decorateClass([
  property({ type: Boolean, attribute: "landing-page-action" })
], QuoteElement.prototype, "landingPageAction");
__decorateClass([
  property({ type: Boolean })
], QuoteElement.prototype, "shouldOverrideQuote");
__decorateClass([
  property({ attribute: false })
], QuoteElement.prototype, "quoteOverride");
__decorateClass([
  state()
], QuoteElement.prototype, "quoteContext");
export {
  QuoteElement
};
